import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';

const NAV = [
  { href: '#programme', label: 'Le programme' },
  { href: '#capacites', label: 'Capacités' },
  { href: '#parcours', label: 'Parcours' },
  { href: '#atelier', label: 'Atelier' },
];

function Mark({ className = 'w-9 h-9' }) {
  return (
    <span
      className={`${className} rounded-lg bg-pine-600 text-parchment flex items-center justify-center shrink-0`}
      aria-hidden
    >
      <svg viewBox="0 0 32 32" className="w-5 h-5" fill="none">
        <path
          d="M8 20c0-5 3.2-8 8-8s8 3 8 8"
          stroke="currentColor"
          strokeWidth="2.2"
          strokeLinecap="round"
        />
        <circle cx="10.5" cy="14" r="1.6" fill="#C4622D" />
        <circle cx="16" cy="11.2" r="1.6" fill="currentColor" />
        <circle cx="21.5" cy="14" r="1.6" fill="#C4622D" />
        <path d="M12 22.5h8" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
      </svg>
    </span>
  );
}

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-parchment/90 backdrop-blur-xl border-b border-sand shadow-soft'
          : 'bg-transparent border-b border-transparent'
      }`}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-[4.25rem]">
          <a href="/" className="flex items-center gap-2.5 group">
            <Mark />
            <span className="leading-tight">
              <span className="block font-display text-[1.15rem] font-semibold tracking-tight">
                IQ Brain Gamers
              </span>
              <span className="hidden sm:block font-mono text-[10px] uppercase tracking-[0.18em] text-clay">
                Jeux cognitifs
              </span>
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-8">
            {NAV.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="text-sm font-semibold text-clay hover:text-pine-600 transition-colors"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="/s"
              className="hidden sm:inline-flex px-5 py-2.5 rounded-md bg-copper-500 text-paper text-sm font-bold hover:bg-copper-400 shadow-stamp transition-colors"
            >
              Commencer
            </a>
            <button
              className="lg:hidden p-2 text-pine-600"
              onClick={() => setOpen((v) => !v)}
              aria-label={open ? 'Fermer le menu' : 'Ouvrir le menu'}
            >
              {open ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-sand bg-paper/95 backdrop-blur-xl px-4 py-5 space-y-3">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={() => setOpen(false)}
              className="block py-2 text-sm font-semibold text-ink"
            >
              {item.label}
            </a>
          ))}
          <a
            href="/s"
            className="block text-center px-5 py-3 rounded-md bg-copper-500 text-paper text-sm font-bold"
          >
            Commencer l'entraînement
          </a>
        </div>
      )}
    </header>
  );
}
